import { PATHS } from '@/constants/Paths';
import { AuthProfile } from '@/types/auth/AuthProfile';
import { UserType } from '@/types/auth/UserType';

export function getProfileLabel(
  profile: AuthProfile,
  t: (key: string) => string,
): string {
  if (profile.userType === UserType.Receiver) {
    return t('auth.profileSelector.receiver');
  }
  if (profile.distributorKind === 'TOUR_OPERATOR') {
    return t('auth.profileSelector.tourOperator');
  }
  return t('auth.profileSelector.travelAgency');
}

export function getDashboardPath(userType: UserType): string {
  if (userType === UserType.Receiver) return PATHS.home.dashboard;
  if (userType === UserType.Distributor) return PATHS.distributors.dashboard;
  return PATHS.admin.dashboard;
}
